import React from "react";
import Ro from "../component/Ro";

const RoDashboard = () => (
  <div>
    <Ro />
  </div>
);

export default RoDashboard;
